// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import App from './App.tsx';
import { createBrowserRouter, RouterProvider } from 'react-router';
import config from './config.ts';
import { ScreenError } from './components';
import configureStore from './store';

Sentry.init({
  dsn: 'https://40a51c72c9732b7be7174f0be8503f52@o100790.ingest.us.sentry.io/4509984669433856',
  sendDefaultPii: true,
  environment: config.APP_ENV,
  enabled: process.env.NODE_ENV !== 'development',
});

const { store } = configureStore();

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <Sentry.ErrorBoundary
        fallback={({ error, eventId, resetError }) => (
          <ScreenError
            error={error instanceof Error ? error : undefined}
            origin="root"
            eventId={eventId}
            invalidate={resetError}
          />
        )}
      >
        <App />
      </Sentry.ErrorBoundary>
    ),
  },
]);

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);
